<!--
 * @Author: your name
 * @Date: 2021-05-17 09:29:53
 * @LastEditTime: 2022-01-10 18:59:55
 * @LastEditors: Smart Chow
 * @Description: In User Settings Edit
 * @FilePath: /nqc-ui/src/frameworks/layouts/components/AppMain.vue
-->
<template>
  <section class="app-main" :style="styleAppMain">
    <router-view v-if="isRouterAlive" />
  </section>
</template>

<script>
import { GetXTMJList } from '@/apps/modules/common/_api/index'
export default {
  name: 'AppMain',
  props: {
    reloading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  computed: {
    key() {
      return this.$route.fullPath
    },
    navStyle() {
      return this.$store.state.app.nav_style
    },
    styleAppMain() {
      let padding = this.navStyle === 'nonNav' ? '8px' : '0px'
      return {
        padding
      }
    }
  },
  watch: {
    reloading(val) {
      this.reload()
    }
  },
  created(){
     this.getSystemDict()
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    getSystemDict(){
      GetXTMJList({ Mjdm: '1139,1143,1232' }).then((res) => {
        if(res && res.success){
          let targetData = res.data.map((item) =>({
             isOpen: item.JLZT === '1' ? true : false,
             code: item.MJDM,
             defaultValue:item.BZ
          }))
          localStorage.setItem('dict',JSON.stringify(targetData))
        }
      })
    }
  }
}
</script>

<style scoped>
.app-main {
  /*84 = navbar + tags-view = 50 +34 */
  /* min-height: calc(100vh - 44px); */
  width: 100%;
  position: relative;
  overflow: hidden;
}
</style>
